<template>
  <div class="form-row mt-4">
    <v-row v-if="empresaGarantia != undefined || empresaNoGarantia != undefined">
      <v-col cols="12">
        <p v-if="calculoSinEmbalaje" class="text--s" style="font-family: Heebo; font-weight: normal">
          Según el diagnóstico del técnico, los costes pueden variar:
        </p>
      </v-col>

      <!-- CARD - COSTES EN GARANTÍA -->
      <v-col cols="12" lg="6">
        <v-card class="mx-auto" max-width="660">
          <v-card-text class="py-0">
            <v-row class="centrar-contenido">
              <p class="text--s  mb-2" style="font-family: Heebo; font-weight: bold">GARANTIA</p>
            </v-row>
            <template v-if="empresaGarantia != undefined">
              <p class="text--m" style="font-family: Heebo; font-weight: normal">
                Las reparaciones en garantía no se aplican
                <span  style="font-family: Heebo; font-weight: bold">costes de rechazo</span>
              </p>
              <p class="text--m" style="font-family: Heebo; font-weight: normal">
                Los <span  style="font-family: Heebo; font-weight: bold">costes de transporte</span> pueden
                tener un precio total de
                {{ esAnovoGarantia ? costesTotalesGarantia : 0 }} €, de
                los cuales
              </p>

              <template v-if="esAnovoGarantia">
                <p class="text--m" style="font-family: Heebo; font-weight: normal">
                  - {{ costesGestionGarantia }} € son
                  <span  style="font-family: Heebo; font-weight: bold">costes de gestion</span>
                </p>
                <p class="text--m" style="font-family: Heebo; font-weight: normal">
                  - {{ costesTransporteGarantia }} € son
                  <span  style="font-family: Heebo; font-weight: bold">costes de logística</span>
                </p>
              </template>
              <p v-if="!calculoSinEmbalaje" class="text--m" style="font-family: Heebo; font-weight: normal"
                - {{ precioEmbalaje }} € son
                <span  style="font-family: Heebo; font-weight: bold">costes del embalaje</span>
              </p>

              <hr style="margin: 6px 0" />
              <p class="text--m" style="font-family: Heebo; font-weight: normal">
                * Todos los precios son aproximados y sin IVA
              </p>
              <p v-if="calculoSinEmbalaje" class="text--m" style="font-family: Heebo; font-weight: normal">
                * En caso de seleccionar embalaje, se añadirá su precio a los
                costes de transporte
              </p>
            </template>
            <template v-else>
              <p class="text--s" style="font-family: Heebo; font-weight: normal">
                No se admiten reparaciones de este dispositivo en garantía
              </p>
            </template>
          </v-card-text>
        </v-card>
      </v-col>

      <!-- CARD - COSTES FUERA DE GARANTÍA -->
      <v-col cols="12" lg="6">
        <v-card class="mx-auto" max-width="660">
          <v-card-text class="py-0">
            <v-row class="centrar-contenido">
              <p class="text--s mb-2" style="font-family: Heebo; font-weight: bold">FUERA DE GARANTÍA</p>
            </v-row>
            <template v-if="empresaNoGarantia != undefined">
              <p v-if="costeRechazoFueraGarantia != 0" class="text--m" style="font-family: Heebo; font-weight: normal">
                El
                <span style="font-family: Heebo; font-weight: bold">
                  rechazo de la elaboración un presupuesto
                </span>
                puede tener un coste de rechazo de {{ costeRechazoFueraGarantia }} €
              </p>
              <p v-else class="text--m" style="font-family: Heebo; font-weight: normal">
                Para consultar
                <span  style="font-family: Heebo; font-weight: bold"> coste del rechazo</span> pongase en
                contacto con sat@zeleris.com o al 900 105 114.
              </p>
              <p class="text--m" style="font-family: Heebo; font-weight: normal">
                Los <span style="font-family: Heebo; font-weight: bold"> costes de transporte </span> pueden
                tener un precio total de {{ costesTotalesFueraGarantia }} €, de
                los cuales
              </p>
              <p class="text--m" style="font-family: Heebo; font-weight: normal">
                - {{ costesGestionFueraGarantia }} € son
                <span style="font-family: Heebo; font-weight: bold">costes de gestion</span>
              </p>
              <p class="text--m" style="font-family: Heebo; font-weight: normal">
                - {{ costesTransporteFueraGarantia }} € son
                <span style="font-family: Heebo; font-weight: bold">costes de logística</span>
              </p>
              <p v-if="!calculoSinEmbalaje" class="text--m" style="font-family: Heebo; font-weight: normal">
                - {{ precioEmbalaje }} € son
                <span style="font-family: Heebo; font-weight: bold">costes del embalaje</span>
              </p>
              <hr style="margin: 6px 0" />
              <p class="text--m" style="font-family: Heebo; font-weight: normal">
                * Todos los precios son aproximados y sin IVA
              </p>
              <p v-if="calculoSinEmbalaje" class="text--m" style="font-family: Heebo; font-weight: normal">
                * En caso de seleccionar embalaje, se añadirá su precio a los
                costes de transporte
              </p>
            </template>
            <template v-else>
              <p class="text--s" style="font-family: Heebo; font-weight: normal">
                No se admiten reparaciones de este dispositivo fuera de garantía
              </p>
            </template>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-row v-else>
      <v-col>
        <p class="text--s" style="font-family: Heebo; font-weight: normal">
          Para consultar coste de la reparación pongase en contacto con
          sat@zeleris.com o al 900 105 114.
        </p>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  props: {
    catalogosReparacion: Array,
    precioEmbalaje: Number,
    calculoSinEmbalaje: Boolean,
  },
  data: () => ({
    tieneSuscripcion: false,
    empresaGarantia: undefined,
    empresaNoGarantia: undefined,
    catalogoGarantia: undefined,
    catalogoFueraGarantia: undefined,
  }),
  created() {
    if (this.$bus.datosUsuario != undefined) this.tieneSuscripcion = true;
    else this.tieneSuscripcion = false;
    if (this.catalogosReparacion.length > 0) {
      // por cada catalogo, buscamos el fabricante al que pertenece
      this.catalogosReparacion.forEach((catalogo) => {
        this.obtenerTaller(catalogo.ID, catalogo.GARANTIA);
        catalogo.GARANTIA ? this.catalogoGarantia = catalogo : this.catalogoFueraGarantia = catalogo;
      })
    }
  },
  methods: {
    /**
     * OBTENER TALLER CORRESPONDIENTE AL CATALOGO
     * @description Llamada a la API para obtener el nombre del taller al que le corresponde el catalogo
     */
    obtenerTaller(val, garantia) {
      let data = {};
      data['idCatalogo'] = val
      this.$API.getEmpresaCatalogo(data).then((response) => {
        if (response != "" && response.empresa.length > 0) {
          garantia ? (this.empresaGarantia = response.empresa) : (this.empresaNoGarantia = response.empresa)
        } else { this.catalogos = []; }
      });
    }
  },
  computed: {
    //costesGarantia() { return this.precioEmbalaje; },

    // ----------------------- CATALOGO EN GARANTIA --------------------------------
    /**
     * Es ANOVO en catalogo en garantia
     * @description Comprueba si es de la empresa ANOVO el taller al que le corresponde la logistica (MAPEO)
     * @return {Boolean} True -> es ANOVO; False -> No lo es
     */
    esAnovoGarantia() {
      return this.empresaGarantia == 'Anovo';
    },

    /**
     * COSTES GESTIÓN CATALOGO EN GARANTIA
     * @description Comprueba si tiene suscripción y si es asi no aplica costes. En caso contrario, le aplica el coste de gestion del catalogo en garantía.
     * @return {Number} Costes de gestión
     */
    costesGestionGarantia() {
      return this.tieneSuscripcion ? 0 : +this.catalogoGarantia.COSTE_GESTION;
    },

    /**
     * COSTES TRANSPORTE CATALOGO EN GARANTIA
     * @description Comprueba si tiene suscripción y si es asi no aplica costes. En caso contrario, le aplica el coste transporte del catalogo en garantía.
     * @return {Number} Costes de transporte
     */
    costesTransporteGarantia() {
      return this.tieneSuscripcion ? 0 : +this.catalogoGarantia.COSTE_TRANSPORTE;
    },

    /**
     * COSTES RECHAZO CATALOGO EN GARANTIA
     * @description Comprueba si tiene coste rechazo.
     * @return {Number} Costes de rechazo
     */
    costeRechazoGarantia() {
      return this.catalogoGarantia.COSTE_RECHAZO_PTO == null
        ? 0
        : this.catalogoGarantia.COSTE_RECHAZO_PTO.toString().replace(".", ",");
    },

    /**
     * CÁLCULO COSTES TOTALES EN GARANTIA
     * @description Calculo de los costes totales del catalogo en garantía
     * @return {Number} Precio del embalaje en caso de tener suscripción y no ser de la empresa ANOVO. Resto de costes para anovo sin suscripcion
     */
    costesTotalesGarantia() {
      if (this.tieneSuscripcion || !this.esAnovoGarantia) return this.precioEmbalaje;
      else {
        return (
          this.catalogoGarantia.COSTE_TRANSPORTE +
          this.catalogoGarantia.COSTE_GESTION +
          this.precioEmbalaje
        );
      }
    },


    // ----------------------- CATALOGO FUERA DE GARANTIA --------------------------------
    /**
     * Es ANOVO en catalogo fuera de garantia
     * @description Comprueba si es de la empresa ANOVO el taller al que le corresponde la logistica (MAPEO)
     * @return {Boolean} True -> es ANOVO; False -> No lo es
     */
    esAnovoFueraGarantia() {
      return this.empresaNoGarantia == 'Anovo';
    },

    /**
     * COSTES GESTIÓN CATALOGO FUERA DE GARANTÍA
     * @description Comprueba si tiene suscripción y si es asi no aplica costes. En caso contrario, le aplica el coste de gestion del catalogo fuera de garantía
     * @return {Number} Costes de gestión
     */
    costesGestionFueraGarantia() {
      return this.tieneSuscripcion ? 0 : +this.catalogoFueraGarantia.COSTE_GESTION;
    },

    /**
     * COSTES TRANSPORTE CATALOGO FUERA DE GARANTÍA
     * @description Comprueba si tiene suscripción y si es asi no aplica costes. En caso contrario, le aplica el coste transporte del catalogo fuera de garantía
     * @return {Number} Costes de transporte
     */
    costesTransporteFueraGarantia() {
      return this.tieneSuscripcion ? 0 : +this.catalogoFueraGarantia.COSTE_TRANSPORTE;
    },

    /**
     * COSTES RECHAZO CATALOGO FUERA DE GARANTÍA
     * @description Comprueba si tiene coste rechazo.
     * @return {Number} Costes de rechazo
     */
    costeRechazoFueraGarantia() {
      return this.catalogoFueraGarantia.COSTE_RECHAZO_PTO == null
        ? 0
        : this.catalogoFueraGarantia.COSTE_RECHAZO_PTO.toString().replace(".", ",");
    },

    /**
     * CÁLCULO COSTES TOTALES FUERA DE GARANTÍA
     * @description Calculo de los costes totales del catalogo fuera de garantía
     * @return {Number} Precio del embalaje en caso de tener suscripción y no ser de la empresa ANOVO. Resto de costes para anovo sin suscripcion
     */
    costesTotalesFueraGarantia() {
      if (this.tieneSuscripcion) return this.precioEmbalaje;
      else {
        return (
          this.catalogoFueraGarantia.COSTE_TRANSPORTE +
          this.catalogoFueraGarantia.COSTE_GESTION +
          this.precioEmbalaje
        );
      }
    },
  },
};
</script>

<style lang="scss" scoped>
    @font-face {
        font-family: 'Heebo';
        src: url('/fonts/heebo-regular.woff');
        font-weight: 400;
    }

    @font-face {
        font-family: 'Heebo';
        src: url('/fonts/heebo-bold.woff');
        font-weight: bold;
    }

.centrar-contenido {
  text-align: center;
}
.negrita {
  font-weight: bold;
}
</style>